import Image from "next/image";
import React from "react";
import dprdLogo from "@/assets/images/dprd-logo.png";
import { cn } from "@/lib/utils";

const Logo = ({ className }: { className?: string }) => {
  return (
    <Image
      src={dprdLogo}
      alt="drpd-logo"
      width={500}
      height={500}
      className={cn("object-cover md:w-16 md:h-16 w-12 h-12", className)}
    />
  );
};

export default Logo;
